<div class="flex flex-column gap-3 mb-4" id="tour-inv-stats">
    <!-- Row 1: Stock Status (3 Cards) -->
    <div class="flex flex-column md:flex-row gap-3">
        <!-- Card 1: Alert -->
        <div class="flex-1 surface-card p-3 shadow-2 border-round border-left-3 border-orange-500 flex justify-content-between align-items-center cursor-pointer hover:bg-orange-50 transition-colors transition-duration-150" 
             [class.bg-orange-50]="activeStatusFilter() === 'alert'"
             (click)="toggleStatusFilter('alert')">
            <div>
                <span class="block text-500 font-medium mb-2">Alerta de Stock</span>
                <div class="text-900 font-bold text-xl">{{ stats().alertStock }}</div>
                <span class="text-500 text-sm">En nivel de alerta</span>
            </div>
            <div class="flex align-items-center justify-content-center bg-orange-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                <i class="pi pi-exclamation-triangle text-orange-500 text-xl" style="line-height: 0"></i>
            </div>
        </div>

        <!-- Card 2: Low Stock -->
        <div class="flex-1 surface-card p-3 shadow-2 border-round border-left-3 border-red-500 flex justify-content-between align-items-center cursor-pointer hover:bg-red-50 transition-colors transition-duration-150" 
             [class.bg-red-50]="activeStatusFilter() === 'low'"
             (click)="toggleStatusFilter('low')">
            <div>
                <span class="block text-500 font-medium mb-2">Stock Crítico</span>
                <div class="text-900 font-bold text-xl">{{ stats().lowStock }}</div>
                <span class="text-500 text-sm">Bajo el mínimo</span>
            </div>
            <div class="flex align-items-center justify-content-center bg-red-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                <i class="pi pi-times-circle text-red-500 text-xl" style="line-height: 0"></i>
            </div>
        </div>

        <!-- Card 3: High Stock -->
        <div class="flex-1 surface-card p-3 shadow-2 border-round border-left-3 border-blue-500 flex justify-content-between align-items-center cursor-pointer hover:bg-blue-50 transition-colors transition-duration-150" 
             [class.bg-blue-50]="activeStatusFilter() === 'high'"
             (click)="toggleStatusFilter('high')">
            <div>
                <span class="block text-500 font-medium mb-2">Exceso de Stock</span>
                <div class="text-900 font-bold text-xl">{{ stats().highStock }}</div>
                <span class="text-500 text-sm">Sobre el máximo</span>
            </div>
            <div class="flex align-items-center justify-content-center bg-blue-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                <i class="pi pi-arrow-up text-blue-500 text-xl" style="line-height: 0"></i>
            </div>
        </div>
    </div>

    <!-- Row 2: Health (2 Cards) -->
    <div class="flex flex-column md:flex-row gap-3">
        <!-- Card 4: Expired -->
        <div class="flex-1 surface-card p-3 shadow-2 border-round border-left-3 border-purple-600 flex justify-content-between align-items-center cursor-pointer hover:bg-purple-50 transition-colors transition-duration-150" 
             [class.bg-purple-50]="activeStatusFilter() === 'expired'"
             (click)="toggleStatusFilter('expired')">
            <div>
                <span class="block text-500 font-medium mb-2">Artículos Vencidos</span>
                <div class="text-900 font-bold text-xl">{{ stats().expiredCount }}</div>
                <span class="text-500 text-sm">Requieren descarte</span>
            </div>
            <div class="flex align-items-center justify-content-center bg-purple-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                <i class="pi pi-calendar-times text-purple-600 text-xl" style="line-height: 0"></i>
            </div>
        </div>

        <!-- Card 5: Expiring Soon -->
        <div class="flex-1 surface-card p-3 shadow-2 border-round border-left-3 border-yellow-500 flex justify-content-between align-items-center cursor-pointer hover:bg-yellow-50 transition-colors transition-duration-150" 
             [class.bg-yellow-50]="activeStatusFilter() === 'expiring'"
             (click)="toggleStatusFilter('expiring')">
            <div>
                <span class="block text-500 font-medium mb-2">Próximos Vencimientos</span>
                <div class="text-900 font-bold text-xl">{{ stats().expiringSoonCount }}</div>
                <span class="text-500 text-sm">Próximos 30 días</span>
            </div>
            <div class="flex align-items-center justify-content-center bg-yellow-100 border-round flex-shrink-0" style="width:2.5rem;height:2.5rem">
                <i class="pi pi-clock text-yellow-600 text-xl" style="line-height: 0"></i>
            </div>
        </div>
        
        <!-- Spacer to maintain 3-column width if desired, or let it be 2 columns wide -->
        <div class="flex-1 hidden md:block"></div>
    </div>

    <!-- Active Filter Indicator -->
    <div *ngIf="activeStatusFilter()" class="flex align-items-center justify-content-between px-3 py-2 bg-primary-50 border-round border-1 border-primary-100 animation-duration-200 fadein">
        <div class="flex align-items-center gap-2">
            <i class="pi pi-filter"></i>
            <span class="text-sm font-medium">Filtrando por: <strong>{{ getStatusLabel(activeStatusFilter()!) }}</strong></span>
        </div>
        <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" (onClick)="clearStatusFilter()" pTooltip="Limpiar filtro" severity="secondary"></p-button>
    </div>
</div>

<div class="surface-card shadow-2 border-round p-4 mt-4">
    <table-dynamic [config]="{
                    title: tableTitle(),
                    columns: cols(),
                    data: data() || [],
                    totalRecords: totalRecords(),
                    first: first(),
                    showFilters: true,
                    selectable: true,
                    globalFilterFields: ['name', 'description', 'brand.name', 'supplier.name', 'form.value', 'regulation.name'],
                    loading: loading(),
                    localFilter: false,
                    showPagination: true,
                    pageSize: pageSize(),
                    onSelectionChange: {
                        emitFullObject: true
                    },
                    lazy: true,
                    hideNewButton: !canManageInventory,
                    sortField: sortField(),
                    sortOrder: sortOrder()
                }" 
        [actionButtons]="actionButtons()" 
        (onDelete)="confirmDelete($event)" 
        (onDeleteAll)="confirmDeleteSelected($event)"
        (onEdit)="openItemHub($event, 'edit')" 
        (onNew)="newItem()"
        (onLazyLoad)="loadData($event)" 
        (onPageChange)="loadData($event)"
        (onDblClick)="openItemHub($event, 'view')"
        [customStartTemplate]="start">
    </table-dynamic>
</div>

<ng-template #start>
    <p-button id="tour-inv-report-btn" label="Reporte por Regulación" icon="pi pi-file-pdf" severity="help" class="mr-2" (onClick)="openReportModal()"></p-button>
    <p-button label="Resumen Ítems Ensayo" icon="pi pi-list" [routerLink]="['/inventory/test-items-summary']" severity="secondary" class="mr-2"></p-button>
</ng-template>

<p-dialog [visible]="showReportModal()" (onHide)="showReportModal.set(false)" [modal]="true" [style]="{width: '450px'}" header="Generar Reporte de Stock" #reportDialog>
    <div class="field">
        <label for="regulationReport">Regulación</label>
        <p-select 
            [options]="regulations()" 
            [ngModel]="selectedRegulationForReport()" 
            (ngModelChange)="selectedRegulationForReport.set($event)"
            optionLabel="label" 
            optionValue="value" 
            placeholder="Seleccione una regulación"
            [style]="{'width':'100%'}"
            [appendTo]="'body'">
        </p-select>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" icon="pi pi-times" (onClick)="showReportModal.set(false)" styleClass="p-button-text"></p-button>
        <p-button label="Generar PDF" icon="pi pi-check" (onClick)="generateReport()" [disabled]="!selectedRegulationForReport()" [loading]="loading()"></p-button>
    </ng-template>
</p-dialog>



<modal-basic 
  *ngIf="showQuickCreateModal()"
  [dialog]="showQuickCreateModal()"
  [item]="quickCreateItem()"
  [fieldConfig]="quickCreateFieldConfig()"
  [buttonsConfig]="quickCreateButtonsConfig()"
  [title]="quickCreateTitle()"
  [isLoadingButton]="loading()"
  (onHide)="hideQuickCreateModal()"
  (onSave)="saveQuickCreate($event)">
</modal-basic>

<!-- Printable area for labels -->
<app-item-label 
    [item]="printItem()" 
    [units]="units()" 
    [suppliers]="suppliers()" 
    [locations]="locations()">
</app-item-label>




